module.exports = __webpack_public_path__ + "static/media/nav-logo-compact.15c29237.svg";